import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { v4 } from 'node-uuid';
import Question from 'help/components/question';
import partial from 'lodash/partial';
import merge from 'lodash/merge';
import {
  trackClickWithMixpanel, MP_CLICKED_PRICING_FAQ_ITEM_EVENT_NAME
} from 'common/tracking';

const FaqList = ({ data, eventTracking, showMore }) => {
  return (
    <div className="faq-list">
      <div className="row">
      { data.map(faq => (
        <div
          key={v4()}
          className="small-16 columns faq"
          onClick={
            !eventTracking? undefined :
            partial(trackClickWithMixpanel, eventTracking.eventName,
                    merge({}, eventTracking.eventData, { question: faq.question }))
          }
        >
          <Question {...faq} />
        </div>
      )) }
      </div>
      { showMore &&
      <div className="row">
        <div className="small-16 columns">
          More questions? {' '}
          <Link target="_blank" to="/help/">
            More answers <i className="fa fa-long-arrow-right"/>
          </Link>
        </div>
      </div> }
    </div>
  );
};

FaqList.propTypes = {
  data: PropTypes.array,
  showMore: PropTypes.bool,
};

export default FaqList;



// WEBPACK FOOTER //
// ./common/components/faqs.jsx